import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const MessageOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.37 3.26H8.09c-2.66 0-4.83 2.32-4.83 5.16V19.7c0 .62.48 1.04.98 1.04.21 0 .43-.08.62-.24l4.23-3.76h7.99c2.01 0 3.66-1.76 3.66-3.91V5.79c0-1.39-1.06-2.53-2.37-2.53Zm.77 9.57c0 1.27-.92 2.31-2.06 2.31H9.09c-.39 0-.77.14-1.06.4l-3.16 2.81V8.42c0-1.96 1.45-3.56 3.23-3.56h10.28c.42 0 .77.42.77.93v7.04h-.01Z" />
      <Path d="M8.54 11.3a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6ZM12.54 8.69c-.72 0-1.3.58-1.3 1.3 0 .72.58 1.3 1.3 1.3.72 0 1.3-.58 1.3-1.3 0-.72-.58-1.3-1.3-1.3ZM16.3 8.69c-.72 0-1.3.58-1.3 1.3 0 .72.58 1.3 1.3 1.3.72 0 1.3-.58 1.3-1.3 0-.72-.58-1.3-1.3-1.3Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MessageOutlined
